import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { makeStyles } from "@material-ui/core/styles";
import ApplicationDetail from "./applicationDetail";
import { DownloadIcon, PrintIcon } from "@egovernments/digit-ui-react-components";
import ReactToPrint from "react-to-print";
import { FaFileExcel } from "react-icons/fa";
import { useTranslation } from "react-i18next";
import { convertEpochToDate } from "@egovernments/digit-ui-module-pt/src/utils";

const useStyles = makeStyles((theme) => ({
  customTab: {
    backgroundColor: "#1F4A7C",
    color: "white",
    marginRight: "3px",
    borderRadius: "3px",
    "&.Mui-selected": {
      backgroundColor: "transparent",
      color: "black",
      border: `1px solid ${theme.palette.primary.main}`,
    },
    printerTab: {
      backgroundColor: "#1F4A7C",
      color: "white",
      marginLeft: "200px",
      borderRadius: "2px",
    },
    printerIcon: {
      verticalAlign: "middle",
      marginLeft: "5px",
    },
  },
}));

function PaymentDetails() {
  const classes = useStyles();
  const [selectedTabIndex, setSelectedTabIndex] = useState("1");
  const [value, setValue] = React.useState("1");
  const componentPDF = React.useRef();
  const [apiData, setApiData] = useState(null);
  const { t } = useTranslation();

  const handleChange = (newValue) => {
    setValue(newValue);
  };
  const handleExcelDownload = () => {
    const charData = apiData?.MisAllExtractData?.map((st, index) => ({
      serialNo: index + 1,
      applicationnumber: st?.applicationnumber || "N/A",
      developmentAuthorityName: st?.developmentAuthorityName || "N/A",
      modulename: st?.modulename || "N/A",
      ownerName: st?.ownerName || "N/A",
      ownermobileno: st?.ownermobileno || "N/A",
      commAdd: st?.commAdd || "N/A",
      siteAddress: st?.siteAddress || "N/A",
      schemeName: st?.schemeName || "N/A",
      status: st?.status || "N/A",
      risk: st?.risk || "N/A",
      plosUse: st?.plosUse || "N/A",
      ltpName: st?.ltpName || "N/A",
      ltpMobilenumber: st?.ltpMobilenumber || "N/A",
      plotArea: st?.plotArea || 0,
      totalBuiltupArea: st?.totalBuiltupArea || 0,
      buildingHeigh: st?.buildingHeigh || 0,
      totalFees: st?.totalFees || 0,
      totalFeeRec: st?.totalFeeRec || 0,
      totalFeesDue: st?.totalFeesDue || 0,
      submissiondate: st?.submissiondate || "N/A",
      approvalDate: st?.approvalDate || "N/A",
      siteInspectionFeesAmount: st?.siteInspectionFeesAmount || 0,
      stackingChargesAmount: st?.stackingChargesAmount || 0,
      strengtheningChargesAmount: st?.strengtheningChargesAmount || 0,
      waterChargesAmount: st?.waterChargesAmount || 0,
      buildingPermissionFeesAmount: st?.buildingPermissionFeesAmount || 0,
      buildingPermitFeesAmount: st?.buildingPermitFeesAmount || 0,
      specialAmenitiesChargesAmount: st?.specialAmenitiesChargesAmount || 0,
      labourCessAmount: st?.labourCessAmount || 0,
      securityDepositChargesforTreePlantationAmount: st?.securityDepositChargesforTreePlantationAmount || 0,
      securityDepositchargesforRainWaterHarvestingAmount: st?.securityDepositchargesforRainWaterHarvestingAmount || 0,
      securityDepositchargesforSolarEnergyAmount: st?.securityDepositchargesforSolarEnergyAmount || 0,
      amalgamationChargesAmount: st?.amalgamationChargesAmount || 0,
      bandhaChargesAmount: st?.bandhaChargesAmount || 0,
      bettermentChargesAmount: st?.bettermentChargesAmount || 0,
      cityDevelopmentChargesAmount: st?.cityDevelopmentChargesAmount || 0,
      compoundingChargesAmount: st?.compoundingChargesAmount || 0,
      developmentFeeAmount: st?.developmentFeeAmount || 0,
      developmentPermitFeeAmount: st?.developmentPermitFeeAmount || 0,
      gstAmount: st?.gstAmount || 0,
      impactFeeAmount: st?.impactFeeAmount || 0,
      licenseFeeforIntegratedTownshipAmount: st?.licenseFeeforIntegratedTownshipAmount || 0,
      maintenanceChargesAmount: st?.maintenanceChargesAmount || 0,
      melaShulkAmount: st?.melaShulkAmount || 0,
      purchasableFARChargesAmount: st?.purchasableFARChargesAmount || 0,
      sewerChargesAmount: st?.sewerChargesAmount || 0,
      shelterfeesAmount: st?.shelterfeesAmount || 0,
      subdivisionChargesAmount: st?.subdivisionChargesAmount || 0,
      villageDevelopmentChargesAmount: st?.villageDevelopmentChargesAmount || 0,
      surplusAmountAmount: st?.surplusAmountAmount || 0,
      securityDepositChargesforMechanicalParkingAmount: st?.securityDepositChargesforMechanicalParkingAmount || 0,
      mapRateFeesAmount: st?.mapRateFeesAmount || 0,
    }));

    return Digit.Download.Excel(charData, "payment-report");
  };
  return (
    <Box sx={{ width: "100%", typography: "body1" }}>
      <TabContext value={value}>
        <Box sx={{ borderBottom: 1, borderColor: "divider", marginLeft: "20px" }}>
          <TabList onChange={handleChange} aria-label="lab API tabs example" defaultIndex={selectedTabIndex}>
            <Tab label="Payment Report" value="1" className={classes.customTab} />
            <ReactToPrint
              trigger={() => (
                <button style={{ marginLeft: "45rem" }} id="invoice-print">
                  <PrintIcon />
                </button>
              )}
              content={() => componentPDF.current}
            />
            <button className="mrlg cursorPointer" onClick={handleExcelDownload} style={{ marginLeft: "3rem" }}>
              <FaFileExcel style={{ fontSize: "22px" }} />
            </button>
          </TabList>
        </Box>
        <div ref={componentPDF}>
          <TabPanel value="1">
            <ApplicationDetail setApiData={setApiData} apiData={apiData} />
          </TabPanel>
        </div>
      </TabContext>
    </Box>
  );
}

export default PaymentDetails;
